module.exports = __webpack_public_path__ + "img/click-logo.4579916c.jpg";